export default {
      id: "button-naverblog-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#button-naverblog",
      toString: function () {
        return this.url;
      }
    }